
import React from "react";
import styles from '../styles/PantallaDeProgramasAcademicos.v2.module.css';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange, className }) => {
  return (
    <div className={styles.paginationWrapper + (className ? ` ${className}` : '')}>
      <nav className={styles.paginationNav} aria-label="Paginación">
        <button
          className={styles.paginationButton}
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          aria-label="Página anterior"
        >
          &#60;
        </button>
        <span className={styles.paginationText} style={{ minWidth: 70, textAlign: 'center' }}>{page} de {totalPages}</span>
        <button
          className={styles.paginationButton}
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          aria-label="Página siguiente"
        >
          &#62;
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
